import actions from './actions'
import { factoryReducer } from '../factory'

const initialState = {
  menuLeftData: [],
}

export default factoryReducer(initialState, actions)
